var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatsSignM(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_797_735)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_797_735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.12012 1.58333C11.7961 1.58333 14.7868 4.574 14.7868 8.25C14.7868 11.926 11.7961 14.9167 8.12012 14.9167C4.44412 14.9167 1.45345 11.926 1.45345 8.25C1.45345 4.574 4.44412 1.58333 8.12012 1.58333ZM8.12012 0.25C3.70212 0.25 0.120117 3.832 0.120117 8.25C0.120117 12.668 3.70212 16.25 8.12012 16.25C12.5381 16.25 16.1201 12.668 16.1201 8.25C16.1201 3.832 12.5381 0.25 8.12012 0.25ZM12.1201 8.91667H4.12012V7.58333H12.1201V8.91667Z",
    fill: "#FB8045"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_797_735"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.120117 0.25)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_797_735"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.120117 0.25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsSignM);
export default __webpack_public_path__ + "static/media/stats_sign_m.43866b16ff6fcc611b3e34c0b850d5e4.svg";
export { ForwardRef as ReactComponent };